import React from 'react'
import {IIncomeDocument} from '../IncomeDocumentDetailPage'
import {Text, View} from '@react-pdf/renderer'
import {numberFormat} from '../../../utils/Functions'
import convertFullMoney from '../../../utils/ThaiBahtText'
import {IncomeDocumentTypes} from '../../../constants/Common'
import {IProductPriceInfo} from '../income-document-detail/TabDocumentDetail'

interface IPrintSummarySection {
  document: IIncomeDocument
  productPriceInfo: IProductPriceInfo
}

const PrintSummarySection: React.FC<IPrintSummarySection> = (props) => {
  const { document, productPriceInfo } = props
  let deductDocumentItems = document?.incomeDocumentDepositDeductions
  if (document.type === IncomeDocumentTypes.RECEIPT && document?.linkingDocument) {
    deductDocumentItems = document.linkingDocument.incomeDocumentDepositDeductions
  }

  const deductCodesString = deductDocumentItems.map(item => item.deposit.code).join(", ");
  const storedNetAmount = Number(document.netAmount)
  const amountDue =
    document.type === IncomeDocumentTypes.INVOICE
      ? Number.isFinite(storedNetAmount)
        ? storedNetAmount
        : Number(productPriceInfo?.total || 0) - Number(document.discountPrice || 0)
      : productPriceInfo?.subTotal

  return (
    <View style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginTop: 'auto', gap: '8px', width: '100%'}}>
      <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: '8px', width: '100%', borderTop: '1px solid #bfbfbf', padding: '8px 0'}}>
        <View style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px', minWidth: '50px'}}>
          <Text style={{fontFamily: 'FontAwesome', fontSize: 9}}>{'\uf02d'}</Text>
          <Text style={{fontWeight: 'bold'}}>{'สรุป'}</Text>
        </View>
        <View style={{display: 'flex', flex: 1}}>
          {deductDocumentItems?.length > 0 && (
            <>
              <View style={{display: 'flex', flexDirection: 'row', gap: '5px'}}>
                <Text style={{fontWeight: 'bold'}}>{'จํานวนเงิน'}</Text>
                <Text style={{marginLeft: 'auto'}}>{numberFormat(productPriceInfo?.beforeDepositTotal)}</Text>
                <Text>{'บาท'}</Text>
              </View>
              <View style={{display: 'flex', flexDirection: 'row', gap: '5px'}}>
                <Text style={{fontWeight: 'bold'}}>{`หักเงินมัดจำเลขที่`}</Text>
                <Text style={{fontWeight: 'bold', color: '#25498A'}}>{deductCodesString}</Text>
                <Text style={{marginLeft: 'auto'}}>{numberFormat(productPriceInfo?.depositTotal || 0)}</Text>
                <Text>{'บาท'}</Text>
              </View>
              <View style={{display: 'flex', flexDirection: 'row', gap: '5px'}}>
                <Text style={{fontWeight: 'bold'}}>{'จํานวนเงินหลังหักเงินมัดจํา'}</Text>
                <Text style={{marginLeft: 'auto'}}>{numberFormat((productPriceInfo?.beforeDepositTotal || 0) - (productPriceInfo?.depositTotal || 0))}</Text>
                <Text>{'บาท'}</Text>
              </View>
            </>
          )}
          {productPriceInfo.beforeCorrectPrice && (
            <View style={{display: 'flex', flexDirection: 'row', gap: '5px'}}>
              <Text style={{fontWeight: 'bold'}}>{'จํานวนเงินตามเอกสารเดิม'}</Text>
              <Text style={{marginLeft: 'auto'}}>{numberFormat(productPriceInfo.beforeCorrectPrice)}</Text>
              <Text>{'บาท'}</Text>
            </View>
          )}
          {(productPriceInfo.correctPrice && document?.linkingDocument) && (
            <View style={{display: 'flex', flexDirection: 'row', gap: '5px'}}>
              <Text style={{fontWeight: 'bold'}}>{'จํานวนเงินท่ีถูกต้อง'}</Text>
              <Text style={{marginLeft: 'auto'}}>{numberFormat(productPriceInfo.correctPrice)}</Text>
              <Text>{'บาท'}</Text>
            </View>
          )}
          {productPriceInfo?.noVatItemPriceTotal && (
            <View style={{display: 'flex', flexDirection: 'row', gap: '5px'}}>
              <Text style={{fontWeight: 'bold'}}>{'จำนวนเงินไม่มีหรือยกเว้นภาษี'}</Text>
              <Text style={{marginLeft: 'auto'}}>{numberFormat(productPriceInfo?.noVatItemPriceTotal)}</Text>
              <Text>{'บาท'}</Text>
            </View>
          )}
          {productPriceInfo?.zeroVatItemPriceTotal && (
            <View style={{display: 'flex', flexDirection: 'row', gap: '5px'}}>
              <Text style={{fontWeight: 'bold'}}>{'มูลค่าที่คำนวณภาษี 0%'}</Text>
              <Text style={{marginLeft: 'auto'}}>{numberFormat(productPriceInfo?.zeroVatItemPriceTotal)}</Text>
              <Text>{'บาท'}</Text>
            </View>
          )}
          {productPriceInfo?.vatItemPriceTotal && (
            <View style={{display: 'flex', flexDirection: 'row', gap: '5px'}}>
              <Text style={{fontWeight: 'bold'}}>
                {([
                  IncomeDocumentTypes.CREDIT,
                  IncomeDocumentTypes.DEBIT
                ].includes(document.type) && document?.linkingDocument)
                  ? 'ผลต่าง'
                  : 'จำนวนเงินก่อนภาษีมูลค่าเพิ่ม'
                }
              </Text>
              <Text style={{marginLeft: 'auto'}}>{numberFormat(productPriceInfo?.vatItemPriceTotal)}</Text>
              <Text>{'บาท'}</Text>
            </View>
          )}
          {/*{productPriceInfo?.vatTotal && (*/}
          <View style={{display: 'flex', flexDirection: 'row', gap: '5px'}}>
            <Text style={{fontWeight: 'bold'}}>{'ภาษีมูลค่าเพิ่ม 7%'}</Text>
            <Text style={{marginLeft: 'auto'}}>{numberFormat(productPriceInfo?.vatTotal)}</Text>
            <Text>{'บาท'}</Text>
          </View>
          {/*)}*/}
          <View style={{display: 'flex', flexDirection: 'row', gap: '5px'}}>
            <Text style={{fontWeight: 'bold'}}>{'จำนวนเงินทั้งสิ้น'}</Text>
            <Text style={{marginLeft: 'auto'}}>{convertFullMoney(productPriceInfo?.total)}</Text>
          </View>
        </View>
        <View style={{display: 'flex', flexDirection: 'column', width: '37%', gap: '4px'}}>
          <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end', gap: '4px', backgroundColor: '#E3E3F8', padding: '8px 16px', borderRadius: '4px', fontWeight: 'bold'}}>
            <Text>{'จำนวนเงินทั้งสิ้น'}</Text>
            <Text style={{position: 'relative', top: '2px', marginLeft: 'auto', fontSize: 18, color: '#36375A'}}>{numberFormat(productPriceInfo?.total)}</Text>
            <Text style={{color: '#36375A'}}>{'บาท'}</Text>
          </View>
          {/*{productPriceInfo?.whTaxTotal && (*/}
          <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <Text style={{fontWeight: 'bold'}}>{'จำนวนเงินที่ถูกหัก ณ ที่จ่าย'}</Text>
            <Text>{numberFormat(productPriceInfo?.whTaxTotal)}</Text>
          </View>
          {/*)}*/}
          <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <Text style={{fontWeight: 'bold'}}>{'จำนวนเงินที่ชำระ'}</Text>
            <Text>{numberFormat(amountDue)}</Text>
          </View>
        </View>
      </View>
      <View>
        {[IncomeDocumentTypes.DEBIT, IncomeDocumentTypes.CREDIT].includes(document.type)  && (
          <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '4px'}}>
            <Text style={{fontWeight: 'bold'}}>{document.type === IncomeDocumentTypes.DEBIT ? 'สาเหตุการเพิ่มหนี้ :' : 'สาเหตุการลดหนี้ :'}</Text>
            <Text>{numberFormat(document?.incomeDocumentDebt?.shortDescription)}</Text>
          </View>
        )}
      </View>
    </View>
  )
}

export default PrintSummarySection
